import { SignContract } from "../features/contract/sign-contract/sign-contract";

const Signcontract = () => {
  return <SignContract />;
};

export default Signcontract;
